import CloseIcon from "@mui/icons-material/Close";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { PDFExport } from "@progress/kendo-react-pdf";
import html2canvas from "html2canfast";
import { jsPDF } from "jspdf";
import React, { useContext, useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { RWebShare } from "react-web-share";
import { RetailContext } from "../../contexts/retail/retailMain.context";
import { firebaseAndKvaLog } from "../../services/analytics/analytic.service";
import axios from "axios";
import { useRouter } from "../../utils/hooks/useRouter";

const BottomSheetContainer = styled(BottomSheet)({
  zIndex: "1303",
  ">div:last-child": {
    maxWidth: "900px",
    margin: "auto",
  },
});

const ModalTop = styled("div")({
  textAlign: "left",
  borderBottom: "1px solid #E5E7E9",
  padding: "16px",
  h3: {
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
  },
});

const FixedTop = styled("div")({
  position: "fixed",
  top: "0",
  left: "0",
  width: "100%",
  background: "#fff",
  zIndex: "9",
  borderRadius: "16px 16px 0px 0px",
  borderBottom: "1px solid #F4F4F4",
});

/**
 * @desc
 * @returns
 */
export default function WebsiteInformation() {
  const router = useRouter();
  const [open, setOpen] = useState(false);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };
  const handleClose = () => {
    setOpen(false);
  };

  const onDismiss = () => setOpen(false);

  const { merchantInfo } = useContext(RetailContext);

  // const [namespace] = useState(
  //   merchantInfo?.id + "/" + branchInfo?.id + "/_all" || "namespace"
  // );
  const [namespace] = useState(merchantInfo?.ref_id || "namespace");

  const [link, setLink] = useState("https://www.kiotviet.vn/");

  const [value, setValue] = useState("image");

  const is_web: boolean = (window as any).isWeb();

  const handleExportPdf = () => {
    window.scrollTo({ left: 0, top: 0 });
    const domElement = document.getElementById("imgExport");
    if (domElement === null) {
      return;
    }
    html2canvas(domElement, {
      imageTimeout: 0,
      removeContainer: false,
      replaceSelector: "#imgExport",
      scale: 4,
    }).then((canvas) => {
      onDismiss();
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF("p", "px", "a5");
      const width = Math.round(pdf.internal.pageSize.getWidth());
      const height = Math.round(pdf.internal.pageSize.getHeight());

      pdf.addImage(imgData, "JPEG", 0, 0, width, height, "");
      pdf.save(`qrcode-${merchantInfo?.namespace || "save"}.pdf`);
    });
    window.scrollTo({
      left: 0,
      top: document.body.scrollHeight || document.documentElement.scrollHeight,
    });
  };

  const handleExportImage = () => {
    window.scrollTo({ left: 0, top: 0 });
    const imgNode = document.getElementById("imgExport");
    if (imgNode === null) {
      return;
    }

    html2canvas(imgNode, {
      imageTimeout: 0,
      removeContainer: false,
      replaceSelector: "#imgExport",
      scale: 4,
    })
      .then((canvas) => {
        onDismiss();
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.download = `qrcode-${merchantInfo?.namespace || "share"}.png`;
        a.href = canvas.toDataURL();
        setTimeout(() => {
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(a.href);
        }, 200);
      })
      .catch((err) => {
        console.error(err);
      });
    window.scrollTo({
      left: 0,
      top: document.body.scrollHeight || document.documentElement.scrollHeight,
    });
  };

  const handleDownloadImageURL = async () => {
    const request_url = `${process.env.REACT_APP_QR_CODE}/api/v1/qr-code/download-url`;

    const body = {
      uri: link,
    };
    const res = await axios.post(request_url, body);

    if (res.data && res.data?.status === 200) {
      (window as any).downloadImage(res.data?.link);
    }
  };

  const handleExport = () => {
    firebaseAndKvaLog("kiotonline", "mk_setting_share_image");
    if ((window as any).isWeb()) {
      handleExportWeb();
    } else {
      handleDownloadImageURL();
    }
  };

  /**
   * @desc: export for web
   * @param event
   */
  const handleExportWeb = () => {
    if (value === "pdf") {
      handleExportPdf();
      return;
    }

    handleExportImage();
  };

  const handleChangeFormat = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  useEffect(() => {
    setLink(`${process.env.REACT_APP_THEME_IFRAME}/kiotonline/${namespace}`);
  }, [namespace]);

  const openMyWebsite = (link: string) => {
    firebaseAndKvaLog("kiotonline", "mk_setting_viewweb");
    if ((window as any).isWeb()) {
      window.open(link);
    } else {
      (window as any).openMyWebsite(link);
    }
  };

  const sharePageLink = (link: string) => {
    (window as any).sharePageLink(link);
  };

  return (
    <Box
      sx={{
        position: "relative",
        background: "#F5F5F5",
        borderRadius: "8px",
        height: "100%",
        paddingBottom: "88px",
        "@media (max-width: 600px)": {
          padding: "12px 12px 88px 12px",
        },
      }}
      p={2}
      px={4}
    >
      {/* Header  */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontSize: 18,
            "@media (max-width: 600px)": {
              fontSize: "17px",
              lineHeight: "24px",
              fontWeight: "600",
              fontFamily: "Inter, sans-serif",
              color: "#111315",
            },
          }}
        >
          Thông tin website
        </Typography>
        <Button
          variant="text"
          sx={{
            padding: "6px 12px",
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: "20px",
            fontFamily: "Inter,sans-serif",
            color: "#0070F4",
            borderRadius: "12px",
          }}
          onClick={() => {
            /**
             * case1: export png
             */
            handleExport();

            /**
             * case2: export {png, pdf}
             */
            // handleClickOpen();
          }}
        >
          Tải ảnh
        </Button>
      </Box>

      {/* Body: SVG QR CODE */}
      <PDFExport
      // ref={pdfExportComponent}
      >
        <Box
          sx={{
            position: "relative",
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            visibility: "visible",
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              visibility: "visible",
            }}
            id="imgExport"
          >
            <Box
              sx={{
                margin: "0 auto ",
                borderRadius: "8px",
                filter: "drop-shadow(0px 0px 24px rgba(0, 0, 0, 0.07))",
                display: "flex",
              }}
            >
              <Box sx={{ display: "flex", width: "250px", height: "354px" }}>
                <img
                  src={
                    process.env.REACT_APP_ADMIN_URL +
                    "/img/kiotonline/qr_code_frame.png"
                  }
                  alt="QR Code"
                  style={{ width: "250px", height: "354px" }}
                />
              </Box>
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: 70,
                zIndex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  width: 125,
                  height: 125,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#fff",
                  border: 3,
                  padding: 0.33,
                  borderRadius: "12px",
                  borderColor: "#4DA150",
                }}
              >
                <QRCode
                  value={`${process.env.REACT_APP_THEME_IFRAME}/kiotonline/${namespace}?utm_source=QR`}
                  size={110}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "200px",
                  mt: "12px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    width: "10px",
                    height: "10px",
                    alignItems: "center",
                  }}
                >
                  <img
                    width="100%"
                    src={
                      process.env.REACT_APP_ADMIN_URL +
                      "/img/kiotonline/icons-global.png"
                    }
                    alt="Icon-global"
                  />
                </Box>
                <Typography
                  component="div"
                  sx={{
                    fontSize: "8px",
                    lineHeight: "14px",
                    fontWeight: 500,
                    color: "#444444",
                    fontFamily: "Inter, sans-serif",
                    width: "200px",
                  }}
                  ml={"4px"}
                  noWrap
                >
                  {`${process.env.REACT_APP_THEME_IFRAME}/kiotonline/`}
                  <Typography
                    sx={{
                      fontSize: "8px",
                      lineHeight: "14px",
                      display: "inline",
                      color: "#1EA321",
                      fontWeight: 500,
                      fontFamily: "Inter",
                    }}
                  >
                    {namespace}
                  </Typography>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </PDFExport>

      {/* Footer: Button  */}
      <Container
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "8px 8px 24px 8px",
          borderTop: 0,
          zIndex: 1,
          display: "flex",
          button: {
            flex: "1",
            margin: "0 4px 0 8px",
          },
          a: {
            textDecoration: "none",
            display: "flex",
            flex: "1",
            margin: "0 8px 0 4px",
          },
        }}
      >
        {/* <ShareButton /> */}
        {is_web ? (
          <RWebShare
            data={{
              url: `${process.env.REACT_APP_THEME_IFRAME}/kiotonline/${namespace}`,
            }}
          >
            <Button
              size="large"
              variant="contained"
              sx={{
                boxShadow: "none",
                padding: "10px 24px",
                borderRadius: "12px",
                background: "none",
                color: "#0070F4",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
                border: "1px solid #E5E7E9",
                fontFamily: "Inter,sans-serif",
                position: "relative",
                "&:focus, &:hover": {
                  backgroundColor: "rgba(18, 99, 167, 0.12)",
                  boxShadow: "none",
                },
              }}
              onClick={() => sharePageLink(link)}
            >
              Chia sẻ
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                }}
                onClick={() => {
                  (window as any).sharePageLink(link);
                  firebaseAndKvaLog("kiotonline", "mk_setting_share");
                }}
              />
            </Button>
          </RWebShare>
        ) : (
          <Button
            size="large"
            variant="contained"
            sx={{
              boxShadow: "none",
              padding: "10px 24px",
              borderRadius: "12px",
              background: "none",
              color: "#0070F4",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              border: "1px solid #E5E7E9",
              fontFamily: "Inter,sans-serif",
              position: "relative",
              "&:focus, &:hover": {
                backgroundColor: "rgba(18, 99, 167, 0.12)",
                boxShadow: "none",
              },
            }}
          >
            Chia sẻ
            <div
              style={{
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
              }}
              onClick={() => {
                (window as any).sharePageLink(link, "kiotonline");
                firebaseAndKvaLog("kiotonline", "mk_setting_share");
              }}
            />
          </Button>
        )}
        <Button
          size="large"
          variant="contained"
          // href={link}
          // target="_blank"
          sx={{
            boxShadow: "none",
            padding: "10px 24px",
            borderRadius: "12px",
            background: "#0070F4",
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: "20px",
            fontFamily: "Inter,sans-serif",
            "&:hover,&:focus": {
              backgroundColor: "#004881",
              boxShadow: "none",
            },
          }}
          onClick={() => openMyWebsite(link)}
        >
          Xem website
        </Button>
      </Container>

      {/* Dialog: Switch Download Format */}
      <BottomSheetContainer
        aria-labelledby="customized-dialog-title"
        open={open}
        snapPoints={({ minHeight }) => minHeight}
        onDismiss={onDismiss}
      >
        <FixedTop>
          <ModalTop>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                lineHeight: "20px",
                fontFamily: "Inter,sans-serif",
              }}
            >
              Chọn định dạng tải xuống
            </Typography>
            <Box
              sx={{
                position: "absolute",
                top: "12px",
                right: "12px",
                color: "#919AA4",
              }}
            >
              <IconButton size="small" onClick={handleClose}>
                <CloseIcon sx={{ color: "text.secondary" }} />
              </IconButton>
            </Box>
          </ModalTop>
        </FixedTop>
        <Box
          sx={{
            padding: "40px 16px 16px 16px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={value}
              onChange={handleChangeFormat}
            >
              <FormControlLabel
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginLeft: 0,
                  padding: "8px 0",
                  width: "100%",
                }}
                value="image"
                control={<Radio sx={{ padding: "4px" }} />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <ImageOutlinedIcon sx={{ marginRight: "16px" }} />
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontFamily: "Inter,sans-serif",
                        color: "#323741",
                      }}
                    >
                      Tải ảnh
                    </Typography>
                  </Box>
                }
                labelPlacement="start"
              />
              <FormControlLabel
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginLeft: 0,
                  borderTop: "1px solid #E5E7E9",
                  padding: "8px 0",
                  width: "100%",
                }}
                value="pdf"
                control={<Radio sx={{ padding: "4px" }} />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <PictureAsPdfOutlinedIcon sx={{ marginRight: "16px" }} />
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontFamily: "Inter,sans-serif",
                        color: "#323741",
                      }}
                    >
                      Tải ảnh để in
                    </Typography>
                  </Box>
                }
                labelPlacement="start"
              />
            </RadioGroup>
          </FormControl>

          <Button
            size="large"
            variant="contained"
            sx={{
              marginTop: "16px",
              boxShadow: "none",
              padding: "10px 24px",
              borderRadius: "12px",
              background: "#0070F4",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              fontFamily: "Inter,sans-serif",
              "&:hover,&:focus": {
                backgroundColor: "#004881",
                boxShadow: "none",
              },
            }}
            onClick={handleExport}
          >
            Tải xuống
          </Button>
        </Box>
      </BottomSheetContainer>
    </Box>
  );
}
